import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c992f79e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c992f79e')) {
      api.createRecord('c992f79e', component.options)
    } else {
      api.reload('c992f79e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c992f79e", function () {
      api.rerender('c992f79e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/installations/index.vue"
export default component.exports